var render = function render(){var _vm=this,_c=_vm._self._c;return _c('three-step-history',{attrs:{"api":"home-status-request","columns":_vm.columns,"done-word":"ປ່ຽນແລ້ວ"}})
}
var staticRenderFns = []

export { render, staticRenderFns }